import { motion } from "framer-motion";

export const fadeUp = {
  hidden: { opacity: 0, y: 36, filter: "blur(6px)" },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export function Reveal({ children, i = 0, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      variants={fadeUp}
      custom={i}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden pt-[0.14em] pb-[0.22em] -mt-[0.14em] -mb-[0.22em] ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "120%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function SectionHeading({ overline, title, description, dark = false, testid }) {
  return (
    <div className="max-w-3xl">
      {overline && (
        <Reveal>
          <p className={`text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase mb-4 ${dark ? "text-ngo-gold" : "text-ngo-leaf"}`}>
            {overline}
          </p>
        </Reveal>
      )}
      <Reveal i={1}>
        <h2
          data-testid={testid}
          className={`text-4xl sm:text-5xl font-bold tracking-tight leading-tight ${dark ? "text-ngo-cream" : "text-ngo-ink"}`}
        >
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal i={2}>
          <p className={`mt-5 text-base md:text-lg leading-relaxed ${dark ? "text-ngo-mint/80" : "text-ngo-ink/70"}`}>
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}
